export var BREAKPOINTS = {
    sm: 450,
    md: 830,
};
//# sourceMappingURL=constants.js.map